import { fetchEcommerceShopContexts, type EcommerceShopContext } from '../api/ecommerceAccounts';
import { useAppStore } from './index';
import { getSystemShopId } from '../utils/shopContext';

// 全局店铺上下文加载，任何修改店铺/账号数据的地方都应在操作后调用此函数，
// 以确保侧边栏的店铺选择器与最新数据保持同步。
export async function loadShopContexts(options?: { silent?: boolean; preferFirst?: boolean }): Promise<EcommerceShopContext[]> {
  const store = useAppStore.getState();
  const silent = options?.silent ?? false;

  if (store.dataSpaceState.dataSpace === 'DEMO') {
    return [];
  }

  if (!silent) {
    store.setShopContextsLoading(true);
  }

  try {
    const records = await fetchEcommerceShopContexts();
    const contexts = records ?? [];
    const { setShopContexts, setCurrentShopId, currentShopId, currentEcomAccountId } = useAppStore.getState();
    setShopContexts(contexts);

    const current = options?.preferFirst ? '' : currentShopId.trim();
    const ecomAccountId = currentEcomAccountId.trim();

    // 检查当前选中的抖音号是否已绑定某个店铺
    const linkedShop = !current && ecomAccountId
      ? contexts.find((ctx) =>
          ctx.douyin_accounts?.some((da) => da.ecom_account_id === ecomAccountId))
      : null;

    // 如果当前抖音号已绑定店铺，自动切换到该店铺
    const hasStandaloneDouyinAccountSelected = !current && ecomAccountId && !linkedShop;
    const nextShopId = current && contexts.some((item) => getSystemShopId(item) === current)
      ? current
      : linkedShop
        ? getSystemShopId(linkedShop)
        : hasStandaloneDouyinAccountSelected
          ? ''
          : getSystemShopId(contexts[0]);
    setCurrentShopId(nextShopId);
    // 如果已绑定的抖音号被映射到店铺，清除独立抖音号选择状态
    if (linkedShop && ecomAccountId) {
      useAppStore.getState().setCurrentEcomAccountId('');
    }
    return contexts;
  } catch (error) {
    console.error('Failed to load shop contexts.', error);
    const { setShopContexts, setCurrentShopId } = useAppStore.getState();
    setShopContexts([]);
    setCurrentShopId('');
    return [];
  } finally {
    if (!silent) {
      useAppStore.getState().setShopContextsLoading(false);
    }
  }
}
